export default "__VITE_ASSET__dd0e474b__"